import * as ng from 'angular';

import {
    PanelHeaderData
} from '../../../atomic-components/molecules/panels/panel-header/panel-header';

export class TemplateTomsController {
    public static $inject: string[] = ['$translate'];

    public nearBottom: boolean;
    public pageHeaderData: PanelHeaderData;

    constructor(private $translate: ng.translate.ITranslateService) {
        this.pageHeaderData = {
            backwardLink: 'account.dataprocessing',
            backwardText: this.$translate.instant('TR_080119-8f744e_TR'),
            panelHeaderRoute: '',
            panelIcon: 'sync-alt',
            panelTitle: this.$translate.instant('TR_030620-aae81c_TR')
        };
    }

}

export class TemplateTomsComponent implements ng.IComponentOptions {
    public template = require('./toms-template.html');
    public controller = TemplateTomsController;
}
